import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '../modules/angular-material/angular-material.module';
import { ColorPickerSquareComponent } from './components/color-picker-square/color-picker-square.component';
import { DataSourceSelectorComponent } from './components/data-source-selector/data-source-selector.component';

@NgModule({
  imports: [
    AngularMaterialModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ColorPickerSquareComponent,
  ],
  declarations: [DataSourceSelectorComponent],
  exports: [DataSourceSelectorComponent, ColorPickerSquareComponent],
})
export class UiComponentsModule {}
